export default __webpack_public_path__ + "static/media/testTube.ce0cec82.png";